import {doc} from '../docs.js';
import {BANG, TIDALS, FIGURES, RULES, PARAMS, TRIGGER, TICK, STOP, START} from "messaging/message-types.js";
import JakiGrid from "effects/midi/jaki/JakiGrid.js";
import * as operationDocs from 'effects/midi/jaki/operations/docs.js';
import JTypes from 'zobject/custom/JTypes.js';

// an object that spits out a simple rule
// similar to scripting where you write rules like
// when(ACCENT).always(LEGATO) 

doc(
    "jgrid",
    {
    },
    "A grid based rule generator for the jaki object",
    (x) => 0,
    {
        tags: "Rhythm",
        inlets: 0,
        operationDocs: operationDocs.doc,
        connects: {
            object: "jaki",
            inlet: "rules"
        }
    }
);

export const jgrid = (object) => {
    let grid = new JakiGrid(object.subSequence, object);
    object.width = 360;
    object.height = 360;
    object.effect = grid;
    object.needsLoad = true;
    return ([type, ...args]) => {
        switch (type) {
        case START:
            grid.calculateRules();
            break;
        }
        // TODO: accept "instructions" that alter the grid
    };
};
 

doc(
    "jtypes",
    {
    },
    "Probabilistically choose a hit type based on user input",
    () => 0,
    {
        inlets: 0
    });

export const jtypes = (object) => {
    let types = new JTypes(object);
    object.width = 220;
    object.height = 134;
    return () => undefined;
};
